import { z } from 'zod'

import {
  DependenciesSchema as GroupedDependenciesSchema,
  AnyDependencySchema,
} from 'shared/api/common/schemas/templates/dependencies'
import { MapSchema } from 'shared/api/common/schemas/templates/map'
import { ModelList } from 'shared/api/common/schemas/templates/modelItems'

const ItemSchema = ModelList.reduce((res, cur, index) => {
  if (!index) {
    res.extend({ model_id: z.string() })
  }
  res.or(cur.extend({ model_id: z.string() }))
  return res
})
const ItemsSchema = z.array(ItemSchema)

const ByIdSchema = z.record(z.string(), ItemSchema)

const ByPathSchema = z.record(z.string(), z.array(z.string()))

export const AdaptedMapSchema = MapSchema.extend({
  items: ItemsSchema,
  byId: ByIdSchema,
  corruptedItems: ItemsSchema,
  hasCorrupted: z.boolean(),
  groupedDependencies: GroupedDependenciesSchema,
  directDependencies: AnyDependencySchema,
  dependencies: AnyDependencySchema,
  byPath: ByPathSchema,
})

export type Items = z.infer<typeof ItemsSchema>
export type ById = z.infer<typeof ByIdSchema>
export type ByPath = z.infer<typeof ByPathSchema>
export type Dependencies = z.infer<typeof AnyDependencySchema>

export type AdaptedMap = z.infer<typeof AdaptedMapSchema>
